<!-- /* Profile */ -->
<p-dialog
  header="{{ 'Profile' | translate }}"
  [(visible)]="profileDialogue"
  [style]="{ width: '50vw' }"
  [baseZIndex]="10000"
  closable="true"
  (onHide)="closeProfileDialog()"
  class="profile"
>
  <form [formGroup]="changeUserNameForm" (ngSubmit)="changeUserName()" novalidate>
    <div class="row">
      <div class="col-md-3">
        <label
          ><b>{{ 'Username' | translate }}</b></label
        >
      </div>
      <div class="col-md-9">
        <div class="d-flex justify-content-between align-items-center">
          <span>{{ username }}</span>
          <span class="edit-icon" (click)="DisplayUsername()">
            <i class="fas fa-pencil-alt"></i>
          </span>
        </div>
        <input
          type="text"
          class="form-control mb-2 mt-2"
          *ngIf="showUsername"
          formControlName="newUserName"
          autocomplete="new-username"
          placeholder="{{ 'New Username' | translate }}"
          maxlength="15"
          required
        />
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-3">
        <label
          ><b>{{ 'Email' | translate }} </b></label
        >
      </div>
      <div class="col-md-9">
        {{ userMail }}
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-3">
        <label
          ><b>{{ 'COUNTRY' | translate }}</b></label
        >
      </div>
      <div class="col-md-9">
        <div class="d-flex justify-content-between align-items-center">
          <span>{{ userCountry }}</span>

          <span class="edit-icon" (click)="DisplayCountryname()">
            <i class="fas fa-pencil-alt"></i>
          </span>
        </div>

        <p-dropdown
          *ngIf="showUserCountry"
          [options]="countries"
          (onChange)="countrySelected()"
          formControlName="country"
          optionLabel="name"
          [filter]="true"
          filterBy="name"
          [showClear]="true"
          placeholder="Select a Country"
          class="mt-2 w-100"
        >
          <ng-template pTemplate="selectedItem">
            <div class="country-item country-item-value" *ngIf="changeUserNameForm?.value?.country?.code">
              <div>
                <span class="fi fi-{{ changeUserNameForm.value.country.code.toLowerCase() }}"></span>
                {{ changeUserNameForm.value.country.name }}
              </div>
            </div>
          </ng-template>

          <ng-template let-country pTemplate="item">
            <div class="country-item">
              <div>
                <span class="fi fi-{{ country.code.toLowerCase() }}"></span>
                {{ country.name }}
              </div>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-12">
        <p-button
          type="submit"
          *ngIf="showUserCountry || showUsername"
          [disabled]="
            (changeUserNameForm.value.country == '' || changeUserNameForm.value.country == null) &&
            changeUserNameForm.value.newUserName == ''
          "
          label="{{ 'Save Changes' | translate }}"
          styleClass="p-button-primary save-changes-btn"
        ></p-button>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-4 mt-3">
        <span (click)="showUserAccountDeleteDialog()" class="delete-account">
          <b>{{ 'Delete Account' | translate }}</b>
          <span class="pi pi-fw pi-chevron-right"></span>
        </span>
      </div>
    </div>
  </form>
</p-dialog>

<!-- /* User Delete */ -->
<p-dialog
  header="{{ 'Why are you deleting your Account?' | translate }}"
  [(visible)]="userAccountDeleteDialogue"
  [style]="{ width: '50vw' }"
  [baseZIndex]="10009"
  [closable]="false"
  (onHide)="closeUserAccountDeleteDialog()"
  class="account-delete"
>
  <form [formGroup]="accountDeleteForm" (ngSubmit)="deleteAccount()" novalidate>
    <div class="row">
      <div class="col-12 mb-2" *ngFor="let reason of accountDeleteReasons">
        <div class="form-check">
          <label class="form-check-label">
            <input type="radio" value="{{ reason.title }}" class="form-check-input" formControlName="reason" />
            <span>{{ reason.title }}</span>
          </label>
        </div>
      </div>
    </div>
    <div class="row mt-5" style="gap: 10px">
      <div class="col-3"></div>
      <button class="btn btn-danger col-3" type="button" (click)="closeUserAccountDeleteDialog()">
        <span translate>Cancel</span>
      </button>
      <button class="btn btn-danger col-3" type="submit" [disabled]="accountDeleteForm.invalid">
        <span translate>Confirm</span>
      </button>
      <div class="col-3"></div>
    </div>
  </form>
</p-dialog>

<!-- /* Change Password */ -->
<p-dialog
  header="{{ 'Change Password' | translate }}"
  [(visible)]="changePasswordDialogue"
  [style]="{ width: '50vw' }"
  [baseZIndex]="10000"
  closable="true"
  (onHide)="closeChangePasswordDialog()"
  class="changepassword"
>
  <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmitChangePassword()" novalidate>
    <div class="row">
      <div class="col-md-3">
        <label>
          <b>{{ 'Old Password' | translate }}</b
          ><i class="text-danger">*</i>
        </label>
      </div>

      <div class="col-md-9">
        <label class="d-block">
          <div class="password-wrapper">
            <input
              [type]="fieldOldPasswordType ? 'text' : 'password'"
              class="form-control passwordField"
              formControlName="oldPassword"
              autocomplete="current-password"
              placeholder="{{ 'Old Password' | translate }}"
              maxlength="30"
              required
            />

            <i
              class="fa passwordShow"
              [ngClass]="{ 'fa-eye-slash': !fieldOldPasswordType, 'fa-eye': fieldOldPasswordType }"
              (click)="toggleOldPasswordType()"
            ></i>
          </div>

          <small
            class="text-danger"
            *ngIf="changePasswordForm.controls.oldPassword.invalid && changePasswordForm.controls.oldPassword.touched"
          >
            {{ 'Require OldPassword' | translate }}
          </small>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <label>
          <b>{{ 'New Password' | translate }}</b
          ><i class="text-danger">*</i>
        </label>
      </div>

      <div class="col-md-9">
        <label class="d-block">
          <div class="password-wrapper">
            <input
              [type]="fieldNewPasswordType ? 'text' : 'password'"
              class="form-control passwordField"
              formControlName="newpassword"
              placeholder="{{ 'New Password' | translate }}"
              maxlength="30"
              pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W).{8,15}$"
              required
            />

            <i
              class="fa passwordShow"
              [ngClass]="{ 'fa-eye-slash': !fieldNewPasswordType, 'fa-eye': fieldNewPasswordType }"
              (click)="toggleNewPasswordType()"
            ></i>
          </div>

          <small
            class="text-danger"
            *ngIf="changePasswordForm.controls.newpassword.touched && changePasswordForm.controls.newpassword.invalid"
          >
            <span *ngIf="changePasswordForm.controls.newpassword.errors?.required">
              {{ 'Require Password' | translate }}
            </span>
            <span *ngIf="changePasswordForm.controls.newpassword.errors?.pattern">
              {{ 'Valid Password' | translate }}
            </span>
          </small>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <label>
          <b>{{ 'Confirm Password' | translate }}</b
          ><i class="text-danger">*</i>
        </label>
      </div>

      <div class="col-md-9">
        <label class="d-block">
          <div class="password-wrapper">
            <input
              [type]="fieldConfirmPasswordType ? 'text' : 'password'"
              class="form-control passwordField"
              formControlName="confirmPassword"
              placeholder="{{ 'Confirm Password' | translate }}"
              maxlength="30"
              required
            />

            <i
              class="fa passwordShow"
              [ngClass]="{ 'fa-eye-slash': !fieldConfirmPasswordType, 'fa-eye': fieldConfirmPasswordType }"
              (click)="toggleConfirmPasswordType()"
            ></i>
          </div>

          <small
            class="text-danger"
            *ngIf="
              changePasswordForm.controls.confirmPassword.touched && changePasswordForm.controls.confirmPassword.invalid
            "
          >
            {{ 'Require Confirm Password' | translate }}
          </small>

          <small
            class="text-danger"
            *ngIf="changePasswordForm.errors?.pwdsDontMatch && changePasswordForm.controls.confirmPassword.valid"
          >
            {{ 'Passwords Match' | translate }}
          </small>
        </label>
      </div>
    </div>
    <div class="text-right mt-3">
      <p-button
        type="submit"
        [disabled]="changePasswordForm.invalid"
        label="{{ 'Save Changes' | translate }}"
        styleClass="p-button-primary save-changes-btn"
      ></p-button>
    </div>
  </form>
</p-dialog>

<!-- /* Login */ -->
<p-toast position="top-center" key="login" [baseZIndex]="15000"></p-toast>
<p-dialog
  header="{{ 'Login' | translate }}"
  [(visible)]="loginDialogue"
  [style]="{ width: '50vw' }"
  [baseZIndex]="10000"
  closable="true"
  (onHide)="closeLoginDialog()"
  class="login-box"
>
  <div *ngIf="verifiationFailed" role="alert" class="p-messages p-component">
    <div
      role="alert"
      class="ng-tns-c1902632395-2 p-message p-message-success ng-trigger ng-trigger-messageAnimation ng-star-inserted"
    >
      <div class="p-message-wrapper" style="padding: 0.2rem 1rem">
        <span class="p-message-icon ng-star-inserted">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="p-icon"
            aria-hidden="true"
          >
            <path
              d="M4.86199 11.5948C4.78717 11.5923 4.71366 11.5745 4.64596 11.5426C4.57826 11.5107 4.51779 11.4652 4.46827 11.4091L0.753985 7.69483C0.683167 7.64891 0.623706 7.58751 0.580092 7.51525C0.536478 7.44299 0.509851 7.36177 0.502221 7.27771C0.49459 7.19366 0.506156 7.10897 0.536046 7.03004C0.565935 6.95111 0.613367 6.88 0.674759 6.82208C0.736151 6.76416 0.8099 6.72095 0.890436 6.69571C0.970973 6.67046 1.05619 6.66385 1.13966 6.67635C1.22313 6.68886 1.30266 6.72017 1.37226 6.76792C1.44186 6.81567 1.4997 6.8786 1.54141 6.95197L4.86199 10.2503L12.6397 2.49483C12.7444 2.42694 12.8689 2.39617 12.9932 2.40745C13.1174 2.41873 13.2343 2.47141 13.3251 2.55705C13.4159 2.64268 13.4753 2.75632 13.4938 2.87973C13.5123 3.00315 13.4888 3.1292 13.4271 3.23768L5.2557 11.4091C5.20618 11.4652 5.14571 11.5107 5.07801 11.5426C5.01031 11.5745 4.9368 11.5923 4.86199 11.5948Z"
              fill="currentColor"
            ></path>
          </svg>
        </span>
        <span class="p-message-detail ng-star-inserted" translate>Your account has been activated successfully</span>
      </div>
    </div>
  </div>
  <form (ngSubmit)="onLoginSubmit()" [formGroup]="loginForm" class="login-box" novalidate>
    <div class="alert alert-danger" [hidden]="!error || isLoading" translate>Username or password incorrect.</div>
    <!-- <div class="form-group mt-2">
      <label
        ><b>{{ 'User Name' | translate }}</b></label
      >
      <label class="d-block">
        <input
          type="text"
          class="form-control"
          formControlName="username"
          autocomplete="username"
          [placeholder]="'User Name' | translate"
        />
        <span hidden translate>{{ 'User Name' | translate }}</span>
        <small
          [hidden]="loginForm.controls.username.valid || loginForm.controls.username.untouched"
          class="text-danger"
          translate
        >
          {{ 'Require Username' | translate }}
        </small>
      </label>
      <label
        ><b>{{ 'Password' | translate }}</b></label
      >
      <label class="d-block">
        <input
          [type]="fieldPasswordType ? 'text' : 'password'"
          class="form-control passwordField"
          formControlName="password"
          autocomplete="current-password"
          [placeholder]="'Password' | translate"
          required
        />
        <i
          class="fa passwordShow"
          [ngClass]="{
            'fa-eye-slash': !fieldPasswordType,
            'fa-eye': fieldPasswordType
          }"
          (click)="togglePasswordType()"
        ></i>
        <span hidden translate>Password</span>
        <small
          [hidden]="loginForm.controls.password.valid || loginForm.controls.password.untouched"
          class="text-danger"
          translate
        >
          {{ 'Require Password' | translate }}
        </small>
      </label>
      <div class="form-check"></div>
    </div> -->
    <div class="form-group mt-2">
      <label>
        <b>{{ 'User Name' | translate }}</b>
      </label>

      <input
        type="text"
        class="form-control"
        formControlName="username"
        autocomplete="username"
        [placeholder]="'User Name' | translate"
      />

      <small class="text-danger" *ngIf="loginForm.controls.username.touched && loginForm.controls.username.invalid">
        {{ 'Require Username' | translate }}
      </small>

      <label class="mt-2 d-block">
        <b>{{ 'Password' | translate }}</b>
      </label>

      <div class="password-wrapper">
        <input
          [type]="fieldPasswordType ? 'text' : 'password'"
          class="form-control passwordField"
          formControlName="password"
          autocomplete="current-password"
          [placeholder]="'Password' | translate"
          required
        />

        <i
          class="fa passwordShow"
          [ngClass]="{
            'fa-eye-slash': !fieldPasswordType,
            'fa-eye': fieldPasswordType
          }"
          (click)="togglePasswordType()"
        ></i>
      </div>
      <small class="text-danger" *ngIf="loginForm.controls.password.touched && loginForm.controls.password.invalid">
        {{ 'Require Password' | translate }}
      </small>
    </div>
    <button class="btn btn-primary w-100" type="submit" [disabled]="loginForm.invalid || isLoading">
      <i class="fas fa-cog fa-spin" [hidden]="!isLoading"></i>
      <span translate>Login</span>
    </button>
  </form>
  <div class="row">
    <div class="col-md-12 mt-3">
      <a (click)="showForgotPasswordDialog()" class="forgotPassword registerLink" style="color: #007bff">
        {{ 'Forgot password' | translate }}?</a
      >
      <span
        >{{ "Don't have one" | translate }},<a
          (click)="showRegistrationDialog()"
          class="forgotPassword registerLink"
          style="color: #007bff"
        >
          {{ 'Register' | translate }}</a
        >
        {{ 'here' | translate }}</span
      >
    </div>
  </div>
</p-dialog>

<!-- /* Forgot Password */ -->
<p-dialog
  header="{{ 'Forgot password' | translate }}"
  [(visible)]="forgotPasswordDialogue"
  [style]="{ width: '50vw' }"
  [baseZIndex]="10000"
  closable="true"
  (onHide)="closeForgotPasswordDialog()"
  class="login-box"
>
  <form (ngSubmit)="onSubmitForgotForm()" [formGroup]="forgotPassForm" novalidate>
    <div class="mt-2">
      <label for="email" class="d-block"
        ><b>{{ 'Email ID' | translate }}</b></label
      >
      <input
        type="email"
        class="form-control"
        placeholder="{{ 'Enter Email' | translate }}"
        formControlName="email"
        id="email"
        required
      />
      <small
        [hidden]="forgotPassForm.controls.email.valid || forgotPassForm.controls.email.untouched"
        class="text-danger"
      >
        {{ 'Valid Email' | translate }}
      </small>
    </div>
    <div class="mt-2">
      <button class="btn btn-primary w-30" type="submit" [disabled]="forgotPassForm.invalid">
        <i class="fas fa-cog fa-spin" [hidden]="!isLoading"></i>
        <span translate>{{ 'Reset Password' | translate }}</span>
      </button>
      <a class="btn btn-primary w-30 float-right" (click)="closeForgotPasswordDialog()">{{ 'Cancel' | translate }}</a>
    </div>
  </form>
</p-dialog>
<p-toast position="top-center" key="forgot" [baseZIndex]="15000"></p-toast>
<p-toast position="top-center" key="forgotAlert" (onClose)="onRejectForgotForm()" [baseZIndex]="15000">
  <ng-template let-message pTemplate="message">
    <div class="p-flex p-flex-column" style="flex: 1">
      <div class="p-text-center info">
        <p class="m-0">{{ confirmMessage }}</p>
        <p class="m-0">{{ confirmMessageSummary }}</p>
      </div>
      <div>
        <div class="p-text-center">
          <p-button label="OK" (click)="onRejectForgotForm()" styleClass="p-button-text"></p-button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>

<!-- Registration -->
<p-toast position="top-right" key="register" [baseZIndex]="15000"></p-toast>
<p-dialog
  header="{{ 'Registration' | translate }}"
  [(visible)]="registrationDialog"
  [style]="{ width: '50vw' }"
  [baseZIndex]="10000"
  closable="true"
  (onHide)="closeRegistrationDialog()"
  class="register-box"
>
  <form (ngSubmit)="onSubmitRegistrationForm()" [formGroup]="registerForm" class="register-box" novalidate>
    <div class="mt-2">
      <label for="mail" class="d-block">
        <b>{{ 'Email ID' | translate }}</b
        ><i class="text-danger" aria-hidden="true">*</i></label
      >
      <input
        type="text"
        formControlName="mail"
        class="form-control"
        placeholder="{{ 'Enter Email' | translate }}"
        name="mail"
        id="mail"
        required
      />
      <div
        *ngIf="
          (registerForm.controls['mail'].invalid && registerForm.controls['mail'].touched) ||
          registerForm.controls['mail'].dirty
        "
      >
        <small *ngIf="registerForm.controls['mail'].errors?.required" class="text-danger">{{
          'Require Email' | translate
        }}</small>
        <small *ngIf="registerForm.controls['mail'].errors?.pattern" class="text-danger">{{
          'Valid Email' | translate
        }}</small>
      </div>
    </div>
    <div class="margin-top">
      <label for="name" class="d-block mt-2"
        ><b>{{ 'User Name' | translate }}</b
        ><i class="text-danger" aria-hidden="true">*</i></label
      >
      <input
        type="text"
        formControlName="name"
        class="form-control"
        placeholder="{{ 'Enter username' | translate }}"
        name="name"
        id="name"
        required
        maxlength="15"
      />

      <small
        [hidden]="registerForm.controls.name.valid || registerForm.controls.name.untouched"
        class="text-danger"
        translate
      >
        {{ 'Require Username' | translate }}
      </small>
    </div>
    <!-- <div class="margin-top">
      <label for="pass" class="mt-2"
        ><b>{{ 'Password' | translate }}</b
        ><i class="text-danger" aria-hidden="true">*</i></label
      >
      <label class="d-block">
        <input
          [type]="fieldPasswordType ? 'text' : 'password'"
          formControlName="pass"
          class="form-control"
          placeholder="{{ 'Enter password' | translate }}"
          name="pass"
          id="pass"
          maxlength="30"
          pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d.*)(?=.*\W.*)[a-zA-Z0-9\S]{8,15}$"
          required
        />
        <i
          class="fa passwordShow"
          [ngClass]="{
            'fa-eye-slash': !fieldPasswordType,
            'fa-eye': fieldPasswordType
          }"
          (click)="togglePasswordType()"
        ></i>
        <span
          *ngIf="
            !registerForm.controls['pass'].valid &&
            (registerForm.controls['pass'].dirty || registerForm.controls['pass'].touched)
          "
        >
          <small class="text-danger" *ngIf="registerForm.controls['pass'].errors?.required">{{
            'Require Password' | translate
          }}</small>
          <small class="text-danger" *ngIf="registerForm.controls['pass'].errors?.pattern">{{
            'Valid Password' | translate
          }}</small>
        </span>
      </label>
    </div> -->
    <div class="margin-top">
      <label for="pass" class="mt-2">
        <b>{{ 'Password' | translate }}</b>
        <i class="text-danger">*</i>
      </label>

      <div class="password-wrapper">
        <input
          [type]="fieldPasswordType ? 'text' : 'password'"
          formControlName="pass"
          class="form-control"
          placeholder="{{ 'Enter password' | translate }}"
          name="pass"
          id="pass"
          maxlength="30"
          pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d.*)(?=.*\W.*)[a-zA-Z0-9\S]{8,15}$"
          required
        />

        <i
          class="fa passwordShow"
          [ngClass]="{
            'fa-eye-slash': !fieldPasswordType,
            'fa-eye': fieldPasswordType
          }"
          (click)="togglePasswordType()"
        ></i>
      </div>

      <small
        class="text-danger"
        *ngIf="
          !registerForm.controls['pass'].valid &&
          (registerForm.controls['pass'].dirty || registerForm.controls['pass'].touched)
        "
      >
        {{ 'Require Password' | translate }}
      </small>

      <small class="text-danger" *ngIf="registerForm.controls['pass'].errors?.pattern">
        {{ 'Valid Password' | translate }}
      </small>
    </div>

    <!-- <div class="margin-top">
      <label for="confirm_pass" class="mt-2"
        ><b>{{ 'Confirm Password' | translate }}</b
        ><i class="text-danger" aria-hidden="true">*</i></label
      >
      <label class="d-block">
        <input
          [type]="fieldConfirmPasswordType ? 'text' : 'password'"
          class="form-control"
          placeholder="{{ 'Enter Confirm password' | translate }}"
          name="confirm_pass"
          id="confirm_pass"
          formControlName="confirm_pass"
          maxlength="30"
          required
        />
        <i
          class="fa passwordShow"
          [ngClass]="{
            'fa-eye-slash': !fieldConfirmPasswordType,
            'fa-eye': fieldConfirmPasswordType
          }"
          (click)="toggleConfirmPasswordType()"
        ></i>
        <span
          class="text-danger"
          *ngIf="
            !registerForm.controls['confirm_pass'].valid &&
            (registerForm.controls['confirm_pass'].dirty || registerForm.controls['confirm_pass'].touched)
          "
        >
          <small *ngIf="registerForm.controls['confirm_pass'].errors?.required">
            {{ 'Require Confirm Password' | translate }}</small
          >
        </span>
        <span
          class="text-danger"
          *ngIf="
            registerForm.controls['confirm_pass'].valid &&
            (registerForm.controls['confirm_pass'].dirty || registerForm.controls['confirm_pass'].touched)
          "
        >
          <small *ngIf="registerForm.controls['pass'].value != registerForm.controls['confirm_pass'].value">{{
            'Passwords Match' | translate
          }}</small>
        </span>
      </label>
    </div> -->

    <div class="margin-top">
      <label for="confirm_pass" class="mt-2">
        <b>{{ 'Confirm Password' | translate }}</b>
        <i class="text-danger">*</i>
      </label>

      <div class="password-wrapper">
        <input
          [type]="fieldConfirmPasswordType ? 'text' : 'password'"
          class="form-control"
          placeholder="{{ 'Enter Confirm password' | translate }}"
          name="confirm_pass"
          id="confirm_pass"
          formControlName="confirm_pass"
          maxlength="30"
          required
        />

        <i
          class="fa passwordShow"
          [ngClass]="{
            'fa-eye-slash': !fieldConfirmPasswordType,
            'fa-eye': fieldConfirmPasswordType
          }"
          (click)="toggleConfirmPasswordType()"
        ></i>
      </div>

      <small
        class="text-danger"
        *ngIf="
          !registerForm.controls['confirm_pass'].valid &&
          (registerForm.controls['confirm_pass'].dirty || registerForm.controls['confirm_pass'].touched)
        "
      >
        {{ 'Require Confirm Password' | translate }}
      </small>

      <small
        class="text-danger"
        *ngIf="
          registerForm.controls['pass'].value !== registerForm.controls['confirm_pass'].value &&
          registerForm.controls['confirm_pass'].touched
        "
      >
        {{ 'Passwords Match' | translate }}
      </small>
    </div>

    <div class="margin-top">
      <label for="country" class="d-block mt-2"
        ><b>{{ 'COUNTRY' | translate }}</b></label
      >
      <p-dropdown
        [options]="countries"
        (onChange)="countrySelected()"
        formControlName="country"
        optionLabel="name"
        [filter]="true"
        filterBy="name"
        [showClear]="true"
        placeholder="Select a Country"
        appendTo="body"
        [baseZIndex]="10001"
      >
        <ng-template pTemplate="selectedItem">
          <div
            class="country-item country-item-value"
            *ngIf="this.registerForm && this.registerForm.value.country.code"
          >
            <div>
              <span class="fi fi-{{ this.registerForm.value.country.code.toLowerCase() }}"></span>
              {{ this.registerForm.value.country.name }}
            </div>
          </div>
        </ng-template>
        <ng-template let-country pTemplate="item">
          <div class="country-item">
            <div><span class="fi fi-{{ country.code.toLowerCase() }}"></span> {{ country.name }}</div>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
    <br />
    <div class="form-check mb-2">
      <label class="form-check-label">
        <input type="radio" value="true" class="form-check-input" formControlName="agreed" />
        <span
          >{{ 'PrivacyPolicy' | translate }}
          <a routerLink="/privacy_policy" (click)="registrationDialog = false">{{ 'PrivacyPolicyLink' | translate }}</a>
          {{ 'PrivacyPolicyReg' | translate }}<i class="text-danger" aria-hidden="true">*</i></span
        >
        <small
          [hidden]="registerForm.controls.agreed.valid || registerForm.controls.agreed.untouched"
          class="text-danger"
          translate
        >
          {{ 'Require PrivacyPolicy' | translate }}
        </small>
      </label>
    </div>
    <div class="form-check mb-2">
      <label class="form-check-label">
        <input type="checkbox" value="true" class="form-check-input" formControlName="subscribe" />
        <span>{{ 'Newsletter' | translate }}*</span>
      </label>
    </div>
    <button class="btn btn-primary w-100 margin-top" type="submit" [disabled]="registerForm.invalid">
      <span>{{ 'Register' | translate }}</span>
    </button>
  </form>
  <div class="signin">
    <p class="mb-0">
      {{ 'AlreadyHaveAccount' | translate }}?
      <a (click)="showLoginDialog()" class="btn btn-link">{{ 'Login' | translate }}</a>
    </p>
  </div>
</p-dialog>

<!-- Reset Password -->
<p-toast position="top-center" key="resetPassword" (onClose)="onRejectResetPasswordForm()" [baseZIndex]="15000">
  <ng-template let-message pTemplate="message">
    <div class="p-flex p-flex-column" style="flex: 1">
      <div class="p-text-center">
        <p class="m-0">{{ confirmMessage }}</p>
        <p>{{ confirmMessageSummary }}</p>
      </div>
      <div>
        <div class="p-text-center">
          <p-button label="OK" (click)="onRejectResetPasswordForm()" styleClass="p-button-text"></p-button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
<p-toast position="top-center" key="deleteUserProfile" (onClose)="onRejectDeleteUser()" [baseZIndex]="15000">
  <ng-template let-message pTemplate="message">
    <div class="p-flex p-flex-column" style="flex: 1">
      <div class="p-text-center">
        <p class="m-0">{{ confirmMessage }}</p>
        <p>{{ confirmMessageSummary }}</p>
      </div>
      <div>
        <div class="p-text-center">
          <p-button label="OK" (click)="deleteUserProfile()" styleClass="p-button-text"></p-button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
<p-dialog
  header="{{ 'Reset Password' | translate }}"
  [(visible)]="resetPasswordDialog"
  [style]="{ width: '50vw' }"
  [baseZIndex]="10000"
  closable="true"
  (onHide)="closeResetPasswordDialog()"
  class="login-box"
>
  <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmitResetPasswordForm()" class="login-box" novalidate>
    <label>{{ 'Current Password' | translate }}<i class="text-danger" aria-hidden="true">*</i></label>
    <label class="d-block">
      <input
        [type]="fieldTempPasswordType ? 'text' : 'password'"
        class="form-control"
        formControlName="tempPassword"
        autocomplete="tempPassword"
        placeholder="{{ 'Current Password' | translate }}"
        maxlength="40"
        required
      />
      <i
        class="fa passwordShow"
        [ngClass]="{
          'fa-eye-slash': !fieldTempPasswordType,
          'fa-eye': fieldTempPasswordType
        }"
        (click)="toggleTempPasswordType()"
      ></i>
      <span hidden translate class="mt-2">Current Password</span>
      <small
        class="text-danger"
        *ngIf="
          !resetPasswordForm.controls['tempPassword'].valid &&
          (resetPasswordForm.controls['tempPassword'].dirty || resetPasswordForm.controls['tempPassword'].touched)
        "
      >
        <span *ngIf="resetPasswordForm.controls['tempPassword'].errors?.required">{{
          'Require CurrentPWD' | translate
        }}</span>
      </small>
    </label>
    <label>{{ 'New Password' | translate }}<i class="text-danger" aria-hidden="true">*</i></label>
    <label class="d-block">
      <input
        [type]="fieldPasswordType ? 'text' : 'password'"
        class="form-control"
        formControlName="password"
        autocomplete="password"
        placeholder="{{ 'New Password' | translate }}"
        maxlength="30"
        pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d.*)(?=.*\W.*)[a-zA-Z0-9\S]{8,15}$"
        required
      />
      <i
        class="fa passwordShow"
        [ngClass]="{
          'fa-eye-slash': !fieldPasswordType,
          'fa-eye': fieldPasswordType
        }"
        (click)="togglePasswordType()"
      ></i>
      <span hidden translate>{{ 'New Password' | translate }}</span>
      <small
        class="text-danger"
        *ngIf="
          !resetPasswordForm.controls['password'].valid &&
          (resetPasswordForm.controls['password'].dirty || resetPasswordForm.controls['password'].touched)
        "
      >
        <span *ngIf="resetPasswordForm.controls['password'].errors?.required">{{ 'Require NewPWD' | translate }}</span>
        <span *ngIf="resetPasswordForm.controls['password'].errors?.pattern">{{ 'Valid Password' | translate }}</span>
      </small>
    </label>
    <label>{{ 'Confirm Password' | translate }}<i class="text-danger" aria-hidden="true">*</i></label>
    <label class="d-block">
      <input
        [type]="fieldConfirmPasswordType ? 'text' : 'password'"
        class="form-control"
        formControlName="confirmPassword"
        autocomplete="current-password"
        placeholder="{{ 'Confirm Password' | translate }}"
        maxlength="30"
        required
      />
      <i
        class="fa passwordShow"
        [ngClass]="{
          'fa-eye-slash': !fieldConfirmPasswordType,
          'fa-eye': fieldConfirmPasswordType
        }"
        (click)="toggleConfirmPasswordType()"
      ></i>
      <span hidden translate>{{ 'Confirm Password' | translate }}<i class="text-danger" aria-hidden="true">*</i></span>
      <small
        [hidden]="
          resetPasswordForm.controls.confirmPassword.valid || resetPasswordForm.controls.confirmPassword.untouched
        "
        class="text-danger"
        translate
      >
        {{ 'Require Confirm Password' | translate }}
      </small>
      <span
        class="text-danger"
        *ngIf="
          resetPasswordForm.controls['confirmPassword'].valid &&
          (resetPasswordForm.controls['confirmPassword'].dirty || resetPasswordForm.controls['confirmPassword'].touched)
        "
      >
        <small
          *ngIf="resetPasswordForm.controls['password'].value != resetPasswordForm.controls['confirmPassword'].value"
          >{{ 'New Passwords Match' | translate }}</small
        >
      </span>
    </label>
    <button type="submit" class="btn btn-primary" [disabled]="resetPasswordForm.invalid">
      {{ 'Reset Password' | translate }}
    </button>
    <a (click)="closeResetPasswordDialog()" class="btn btn-primary float-right">{{ 'Cancel' | translate }}</a>
  </form>
</p-dialog>

<!-- Toast notifications -->
<p-toast position="top-center" key="logout" [baseZIndex]="15000"></p-toast>
<p-toast position="top-center" key="changeuser" [baseZIndex]="15000"></p-toast>
<p-toast position="center" key="c" (onClose)="onReject()" [baseZIndex]="15000">
  <ng-template let-message pTemplate="message">
    <div class="p-flex p-flex-column" style="flex: 1">
      <div class="p-text-center info">
        <p>{{ confirmMessage }}</p>
        <p>{{ confirmMessageSummary }}</p>
      </div>
      <div>
        <div class="p-text-center">
          <p-button label="OK" (click)="onReject()" styleClass="p-button-text"></p-button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
